import axios from 'axios';
import router from '@/router';
import baseUrl from '@/config/setBaseUrl';
import { decodeBase64, isYoJiangApp, getYoJiangAppLoginInfo } from '@/common/js/utils';
// eslint-disable-next-line import/no-cycle
import store from '@/store/index';
import { Toast } from 'vant';

if (isYoJiangApp()) {
  const loginInfo = getYoJiangAppLoginInfo();

  if (loginInfo && (loginInfo.session || loginInfo.xsrftoken || loginInfo.cookie)) {
    axios.defaults.headers.common['X-Session'] = loginInfo.session;
    axios.defaults.headers.common['X-UUID'] = loginInfo.uuid;
    axios.defaults.headers.common['X-Xsrftoken'] = loginInfo.xsrftoken;
    axios.defaults.headers.common['X-AppId'] = loginInfo.appid;
  }
}

const configObj = {
  baseURL: baseUrl,
  timeout: 60 * 1000, // Timeout
  withCredentials: true, // Check cross-site Access-Control
};

const request = axios.create(configObj);

request.interceptors.request.use(config => config, (error) => {
  console.error(error);
});

// Add a response interceptor
request.interceptors.response.use(
  (response) => {
    // Do something with response data
    if (+response.status !== 200) {
      return response;
    }

    // 解密数据
    if (response.encrypt_ver === 1 && response.data) {
      try {
        const buf = response.data.replace(/\n/g, '').split('');
        for (let i = 0; i < Math.floor(buf.length / 3); i++) {
          const c = buf[i * 3];
          buf[i * 3] = buf[i * 3 + 2];
          buf[i * 3 + 2] = c;
        }
        response.data = JSON.parse(decodeBase64(buf.join('')));
      } catch (err) {
        console.error(err);
      }
    }

    if (response.data.code === -3) {
      const loginUrl = `/login?next_url=${window.location.href}`;

      Toast({
        duration: 1000,
        message: response.data.message
      });

      setTimeout(() => {
        router.replace(loginUrl);
      }, 1000);

      return Promise.reject(response.data);
    }

    if (!response.data.success && response.data.message) {
      Toast({
        duration: 1000,
        message: response.data.message
      });
    }

    // 将当前网络时间保存到vuex中
    if (response.headers.date) {
      const date = new Date(response.headers.date);
      const offsetGMT = new Date().getTimezoneOffset();
      const realDate = new Date(date.getTime() + offsetGMT * 60000 + 8 * 60 * 60 * 1000);

      // eslint-disable-next-line no-restricted-globals
      if (isNaN(date)) {
        return response.data;
      }

      if (!store.state.currentDateObj) {
        store.commit('SET_CURRENTDATE', realDate);
      } else {
        // 当前时间比vuex里保存的时间不是同一天，就更新数据
        // eslint-disable-next-line no-bitwise
        const currDay = realDate.toLocaleDateString().split('/')[2] | 0;
        // eslint-disable-next-line no-bitwise
        const agoDay = store.state.currentDateObj.toLocaleDateString().split('/')[2] | 0;

        if (currDay - agoDay > 0) {
          store.commit('SET_CURRENTDATE', realDate);
        }
      }
    }

    return response.data;
  },
  (error) => {
    // Do something with response error
    const { status } = error.response;
    switch (status) {
      case 500:
        console.error('error', '服务器内部错误');
        Toast.fail({
          duration: 1000,
          message: '服务器内部错误'
        });
        break;
      case 404:
        console.error('error', '未找到远程服务器');
        break;
      case 401:
        console.error('warning', '用户登陆过期，请重新登陆');
        Toast.fail({
          duration: 1000,
          message: '用户登陆过期，请重新登陆'
        });
        break;
      case 400:
        console.error('error', '数据异常，详情请咨询有讲课堂服务热线');
        Toast.fail({
          duration: 1000,
          message: '数据异常，详情请咨询有讲课堂服务热线'
        });
        break;
      default:
        console.error('error', error);
    }
    return Promise.reject(error);
  },
);

export default request;
